import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyCalculationInterface } from '../interfaces/currency-calculation.interface';
import { AmountInterface } from '../../layout/interfaces/amount-interface';
import { RatesService } from '../services/rates.service';
import { ExchangeCalculatorService } from '../../shared/services/exchange-calculator.service';
import { RateInterface } from '../../layout/interfaces/rate-interface';

@Pipe({
  name: 'alpicurrency',
  standalone: true
})
export class CurrencyPipe implements PipeTransform {
  protected currencyCalculation: CurrencyCalculationInterface;

  constructor(
    private ratesService: RatesService,
    private exchangeCalculator: ExchangeCalculatorService
  ) {}

  /**
   * Divides a given number, set the decimal place to 2
   * and adds a currency-sign for the given currency-string.
   *
   * @param value the money value for example 1599
   * @param currency the currency you want to display (EUR,USD,..)
   * @param round boolean
   * @param withCurrencyCode boolean
   * @param rates
   *
   * @return string
   */
  transform(
    value: number | AmountInterface,
    currency?: string,
    round?: boolean,
    withCurrencyCode = true,
    rates?: RateInterface
  ): string {
    if (typeof value === 'undefined') {
      value = 0;
    }
    if (rates) {
      value = {
        amount: typeof value === 'number' ? value : value.amount,
        currency: rates
      };
    }
    value = this.ratesService.patchRate(value);
    return this.exchangeCalculator.exchange(value, currency, round ? 0 : 2, withCurrencyCode);
  }
}
